import React from "react";
import { KPICard } from "./KPICard";
import { KPIData } from "../types";

interface KPIRowProps {
  kpis: KPIData[];
}

export const KPIRow: React.FC<KPIRowProps> = ({ kpis }) => {
  return (
    <section className="grid grid-cols-4 gap-4 xl:grid-cols-2 lg:grid-cols-1">
      {kpis.map((kpi, index) => (
        <KPICard key={index} data={kpi} />
      ))}
    </section>
  );
};
